import { render } from "./MapLoader.vue?vue&type=template&id=e6497ce2&ts=true"
import script from "./MapLoader.vue?vue&type=script&lang=ts"
export * from "./MapLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__